import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';

const index = ({ cell }) => {
  const displayVal =
    cell?.row?.original?.patchDetail?.version || cell?.row?.original?.version;
  return (
    <div className={`flex actr pr8 mw-100 cell full-height full-width`}>
      <div className="ellipsis" title={displayVal}>
        {displayVal ? <div>{displayVal}</div> : <DisabledTag>NA</DisabledTag>}
      </div>
    </div>
  );
};

export default index;
